const AS_HAWAIIAN = /\bas\s+hawaiian\b/i;

/**
 * TODO: one-off flights scenario. Hawaiian Airlines (recently bought by Alaska) is the
 * only carrier whose logo should differ from the marketing carrier. If this becomes a
 * pattern across airlines, move it into a shared backend model.
 *
 * Airline code for a segment's logo. Alaska flies Hawaiian-branded flights as
 * marketing == operating == AS, with the only Hawaiian signal in `codeSharedCarrier`
 * (e.g. "ALASKA AS HAWAIIAN AIRLINES"). Return HA for those, else the marketing code
 * (so flight number and name stay AS). FI-1599.
 */
export function logoAirlineCode(
  marketingAirlineCode: string,
  codeSharedCarrier?: string | null
): string {
  return codeSharedCarrier && AS_HAWAIIAN.test(codeSharedCarrier)
    ? "HA"
    : marketingAirlineCode;
}

/**
 * Slice-level logo code: HA if any segment is Hawaiian-branded (the trans-Pacific leg
 * of a multi-stop trip is often the Hawaiian one), else the slice marketing carrier.
 * Used where a single logo represents the whole slice (shop cards). FI-1599.
 */
export function sliceLogoAirlineCode(
  marketingAirlineCode: string,
  segments: ReadonlyArray<{ codeSharedCarrier?: string | null }> | undefined
): string {
  const hawaiian = segments?.some(
    ({ codeSharedCarrier }) =>
      !!codeSharedCarrier && AS_HAWAIIAN.test(codeSharedCarrier)
  );
  return hawaiian ? "HA" : marketingAirlineCode;
}
